enum InputState {
  Valid,
  Warning,
  Error,
}
export default InputState;
